export default class QueryParams {
    public static readonly TRANSACTION_ID = 'tid';
    public static readonly SESSION_ID = 'sid';
    public static readonly CSRF_TOKEN = 'rf';
    public static readonly INIT = 'init';
}
